export default __webpack_public_path__ + "static/media/station_processes.b147d44c.png";